// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2iNuu","file":"styles_file__3-yDZ"};